import { Avatar, Box, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { TextField, TextArea, Button } from '@bechtel/gds';

export const GeneralContainerStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  height: 100vh;
`;

export const GeneralHeaderStyled = styled(Box).attrs({ px: { sm: '500' }, pt: { sm: '600' }, pb: { sm: '550' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const GeneralSubContainerStyled = styled(Box).attrs({
  mx: { sm: '500' },
  mt: { sm: '500' },
})`
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  overflow-y: auto;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const GeneralInnerBlockStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  height: fit-content;
  ${({ theme }) => `border-bottom: 1px solid ${theme.colors.grey[300]};`}
`;

export const ImagePreviewContainerStyled = styled(Box)`
  ${({ theme }) => `border: 1px solid ${theme.colors.grey[300]};`}
`;

export const FooterButtonStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;

export const GeneralFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding: ${theme.spacings[300]} ${theme.spacings[600]};
    white-space: nowrap;
  `}
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme }) => css`
    border-color: ${theme.colors.white};
    background-color: ${theme.colors.grey[200]};
  `}
`;

export const TextInputStyled = styled(TextField)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;

export const TextAreaStyled = styled(TextArea)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;

export const UserItemStyled = styled(Box).attrs({
  ml: { sm: '500' },
  pt: { sm: '400' },
  pb: { sm: '400' },
  mb: { sm: '100' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) =>
    css`
      border-bottom: solid 0px ${theme.colors.grey['300']};
    `}
`;

export const PhotoContainerStyled = styled.div`
  position: relative;
  ${({ theme }) =>
    css`
      border: 1px solid ${theme.colors.grey[300]};
      margin-bottom: ${theme.spacings[400]};
    `}
`;

export const DeletePhotoStyled = styled.div`
  ${({ theme }) =>
    css`
      position: absolute;
      top: ${theme.spacings[400]};
      right: ${theme.spacings[400]};
    `}
`;
